import { useAuth0 } from '@auth0/auth0-vue';
import { useRouter } from 'vue-router';
import { useMyStore } from '../store';

export function useInactivityTracker(timeoutMinutes = 15) {
  const { logout } = useAuth0();
  const router = useRouter();
  const store = useMyStore();
  let inactivityTimer;
  let inactivityCheckInterval;
  let lastActivityTime = Date.now();

  const logoutUser = async () => {
    try {
      await store.fullLogout(
        logout,
        router,
        Capacitor.isNativePlatform(),
        import.meta.env.VITE_BUNDLE_ID,
        import.meta.env.VITE_AUTH0_DOMAIN
      );
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  // const logoutUser = async () => {
  //   try {
  //     await store.captureNetWorth();
  //   } catch (error) {
  //     console.error('Error capturing net worth on logout:', error);
  //   }
  //   console.log('Inactivity timeout triggered - logging out');

  //   logout({ localOnly: true });

  //   localStorage.removeItem('authToken');
  //   localStorage.removeItem('userInfo');
  //   store.updateUserLoggedIn(false);
  //   router.push('/');
  // };

  const resetTimer = () => {
    lastActivityTime = Date.now();
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(logoutUser, timeoutMinutes * 60 * 1000);
  };

  const checkInactivity = () => {
    const currentTime = Date.now();
    if (currentTime - lastActivityTime >= timeoutMinutes * 60 * 1000) {
      logoutUser();
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      localStorage.setItem('lastActivityTime', String(lastActivityTime));
      clearTimeout(inactivityTimer);
    } else {
      const stored = Number(localStorage.getItem('lastActivityTime') || 0);
      if (stored && Date.now() - stored >= timeoutMinutes * 60 * 1000) {
        logoutUser();
        return;
      }
      lastActivityTime = stored || Date.now();
      resetTimer();
    }
  };

  const setupActivityListeners = () => {
    // Desktop events
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('click', resetTimer);
    window.addEventListener('scroll', resetTimer);

    // Mobile touch events
    window.addEventListener('touchstart', resetTimer);
    window.addEventListener('touchmove', resetTimer);
    window.addEventListener('touchend', resetTimer);

    document.addEventListener('visibilitychange', handleVisibilityChange);

    resetTimer();
    inactivityCheckInterval = setInterval(checkInactivity, 10_000); // Check every 10 seconds
  };

  const cleanup = () => {
    clearTimeout(inactivityTimer);
    clearInterval(inactivityCheckInterval);

    window.removeEventListener('mousemove', resetTimer);
    window.removeEventListener('keydown', resetTimer);
    window.removeEventListener('click', resetTimer);
    window.removeEventListener('scroll', resetTimer);

    window.removeEventListener('touchstart', resetTimer);
    window.removeEventListener('touchmove', resetTimer);
    window.removeEventListener('touchend', resetTimer);

    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };

  return {
    setupActivityListeners,
    cleanup,
  };
}
